import { useEffect } from "react"
// import { useLocation } from "@reach/router"
import ReactGA from "react-ga4"
import { checkCookiesAccepted } from "../lib/cookies"

const useGoogleAnalytics = () => {
  // const location = useLocation()
  const cookiesAccepted = checkCookiesAccepted()

  useEffect(() => {
    if (
      cookiesAccepted &&
      process.env.hasOwnProperty("REACT_APP_GA_PROPERTY_ID") &&
      process.env.REACT_APP_GA_PROPERTY_ID !== ""
    ) {
      ReactGA.initialize(process.env.REACT_APP_GA_PROPERTY_ID)
    }
  }, [cookiesAccepted])

  // New ReactGA4 pageview
  // ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });

  // Old ReactGA pageview
  // useEffect(() => {
  //   // console.log(location.pathname + location.search)
  //   if (cookiesAccepted) {
  //     ReactGA.pageview(location.pathname + location.search)
  //   }
  // }, [cookiesAccepted, location])
}

export default useGoogleAnalytics
